import React, { Component } from 'react'

export default class CommunicationBetweenTwoComponent extends Component {
    render() {
        return (
            <div>
                <ProductBasicDeatilComponent  ProductName="Milk" ProductPrize="24Rs" ProductCategory="Dairy" IsRequired="No" ProductExpiry = "24Hour"
                ProductWarning ="Keep In Cool Place"></ProductBasicDeatilComponent>
            </div>
        )
    }
}

class ProductBasicDeatilComponent extends Component {
    constructor(props){
        super(props)
        this.state={
            warning:this.props.ProductWarning,
        }
    }
    WarningChangeDetection =(warnings) =>{
       this.setState({warning:warnings})
    }
    render() {
        return (
            <div>
                <h1>Product Deatail</h1>
                <p><label>ProductName:--</label><b>{this.props.ProductName}</b> {}</p>
                <p><label>ProductPrize:--</label><b>{this.props.ProductPrize}</b> {}</p>
                <p><label>ProductCategory:--</label><b>{this.props.ProductCategory}</b> {}</p>
                <p><label>IdRequired:--</label><b>{this.props.IsRequired}</b> {}</p>
                <p><label>Warning:--</label><b>{this.state.warning}</b> {}</p>
                 <ProductGroundDeatilComponent ProductExpiry={this.props.ProductExpiry} ProductWarning = {this.props.ProductWarning} 
                 handleWarning = {this.WarningChangeDetection}></ProductGroundDeatilComponent>
            </div>
        )
    }
}

class  ProductGroundDeatilComponent extends Component {

    constructor(props){
        super(props)
        this.state={
            ProductWarning:this.props.ProductWarning
        }
    }
    updateWarning = () => {
        let tempwarning= this.refs.ProductWarning.value
        this.props.handleWarning(tempwarning);
    }
    render(){
        return(
            <div>
                <h1>Product Ground Detail</h1>
                <p><lable>ProductExpiry-</lable><b>{this.props.ProductExpiry}</b></p>
                <p><lable>ProductWarning-</lable> <input type="text"  defaultValue={this.state.ProductWarning}  ref="ProductWarning"/></p>
                <button onClick={this.updateWarning}>Update</button>
            </div>
        )
    }
}